import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TextButton } from '@amzn/storm-ui';

const ProgressPillContainer = styled(TextButton)`
  display: inline-block;
  position: relative;
  width: 50px;
  height: 4px;
  border-radius: 2px;
  margin-right: ${({ theme }) => theme.spacing.xxsmall.default};

  &:hover {
    background-color: ${({ theme }) => theme.color.gray[0]};
  }

  &:last-child {
    margin-right: 0;
  }

  &::before {
    content: '';
    background-color: ${({ theme }) => theme.color.gray[0]};
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    opacity: 30%;
  }
`;
ProgressPillContainer.displayName = 'ProgressPillContainer';

const ProgressPillFill = styled.span`
  display: block;
  position: relative;
  height: 4px;
  border-radius: 2px;
  width: ${({ value }) => value}%;
  background-color: ${({ theme }) => theme.color.gray[0]};
`;
ProgressPillFill.displayName = 'ProgressPillFill';

const CarouselProgressPillComponent = (props) => {
  const { className, isActive, isPlaying, max, onClick, value, ariaLabel } =
    props;

  let calcValue = (value / max) * 100;
  if (isActive && !isPlaying) {
    calcValue = 100;
  }

  return (
    <ProgressPillContainer
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <ProgressPillFill value={calcValue} />
    </ProgressPillContainer>
  );
};

CarouselProgressPillComponent.propTypes = {
  // ClassName provided by styled-component used for targeting the styled-component with CSS from
  // the parent.
  className: PropTypes.string.isRequired,
  // Controls whether the pill should be displayed in an active state.
  isActive: PropTypes.bool,
  // Controls whether the pill should be considered "playing".
  isPlaying: PropTypes.bool,
  // Maximum total value for progress. Defaults to 100.
  max: PropTypes.number,
  // Click callback for the Pill, used to navigate to the slide at the Pill's index in the Carousel.
  onClick: PropTypes.func,
  // The current value of progress of the pill.
  value: PropTypes.number,
  // The aria label of progress pill button for screen reader.
  ariaLabel: PropTypes.string,
};

CarouselProgressPillComponent.defaultProps = {
  isActive: false,
  isPlaying: false,
  max: 100,
  onClick: () => {},
  value: 0,
  ariaLabel: '',
};

const CarouselProgressPill = styled(CarouselProgressPillComponent)``;
CarouselProgressPillComponent.displayName = 'CarouselProgressPill';

export default CarouselProgressPill;
